import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchIllustrationStatusByRequestIdRequest } from '../model/illustrationModel';
import { updateQuoteWithIllustrationData } from '../model/quotesModel';
import { selectIllustration } from '../model/selectors';

export function useIllustrationPolling() {
  const dispatch = useDispatch();
  const illustration = useSelector(selectIllustration);
  const processedIllustrations = useRef<Set<string>>(new Set());

  useEffect(() => {
    const activeRequests = illustration.activeRequests || {};
    const pollingRequests = Object.values(activeRequests).filter(
      request => request.status === 'polling' && request.requestId
    );

    if (pollingRequests.length === 0) {
      return;
    }

    const fiveSeconds = 5000;
    const intervalId = setInterval(() => {
      pollingRequests.forEach(request => {
        dispatch(fetchIllustrationStatusByRequestIdRequest({ requestId: request.requestId }));
      });
    }, fiveSeconds);

    return () => clearInterval(intervalId);
  }, [illustration.activeRequests, dispatch]);

  useEffect(() => {
    const completedIllustrations = illustration.completedIllustrations || {};
    
    Object.values(completedIllustrations).forEach((completedIllustration: any) => {
      const illustrationKey = `${completedIllustration.requestId}-${completedIllustration.insuranceQuoteId}`;
      if (processedIllustrations.current.has(illustrationKey)) {
        return;
      }

      if (completedIllustration.pdfUrl && completedIllustration.responseData) {
        dispatch(updateQuoteWithIllustrationData({
          insuranceQuoteId: completedIllustration.insuranceQuoteId,
          responseData: completedIllustration.responseData,
          pdfUrl: completedIllustration.pdfUrl,
        }));
        processedIllustrations.current.add(illustrationKey);
      }
    });
  }, [illustration.completedIllustrations, dispatch]);
} 